import { useMemo } from 'react'

import { useQuery } from '@tanstack/react-query'

import axios from 'axios'

// Fetches the current session's image-generation runs so the Create tab
// conversation can be restored after a reload (it otherwise lives only in state).
function useSessionImageGenerations(sessionId) {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['imageGenerations', String(sessionId)],
    queryFn: async () => {
      const { data: responseData } = await axios.get('/api/internal/generator/image-generations', {
        params: { generator_session_id: sessionId },
      })

      return responseData.data || []
    },
    enabled: sessionId != null,
    // Closing the panel remounts the tabs, so this refetches every time it reopens.
    // The global 5-minute staleTime would otherwise replay the snapshot taken while a
    // run was still processing, restoring a spinner for a generation already finished.
    staleTime: 0,
    refetchOnMount: 'always',
  })

  const generations = useMemo(() =>
    (data ?? [])
      .map((item) => ({ ...item.attributes, id: item.id }))
      .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt)),
    [data],
  )

  return { generations, isLoading, isError }
}

export default useSessionImageGenerations
